import { Controller } from "@hotwired/stimulus";

/**
 * Supplier Quote Item Controller
 *
 * This controller manages the calculation of totals for each line item
 * in a supplier quote form.
 */
export default class extends Controller {
  static targets = ["quantity", "unitPrice", "total"];

  connect() {
    this.calculateTotal();
  }

  /**
   * Calculate the total price for this line item
   * based on quantity and unit price values
   */
  calculateTotal() {
    if (
      this.hasQuantityTarget &&
      this.hasUnitPriceTarget &&
      this.hasTotalTarget
    ) {
      const quantity = parseFloat(this.quantityTarget.value) || 0;
      const unitPrice = parseFloat(this.unitPriceTarget.value) || 0;
      const total = quantity * unitPrice;

      // Format the total with the appropriate currency format
      this.totalTarget.textContent = this.formatCurrency(total);

      // Dispatch an event to notify the parent form that an item total has changed
      this.dispatch("totalChanged", { detail: { total: total } });
    }
  }

  /**
   * Format a number as currency (F CFA)
   * @param {Number} amount - The amount to format
   * @returns {String} Formatted currency string
   */
  formatCurrency(amount) {
    // Format the number with thousand separators and 0 decimals
    const formattedAmount = new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

    return `${formattedAmount} F CFA`;
  }
}
